module.exports = __webpack_public_path__ + "img/us.96199c9e.jpg";